import './toastsNotificationStyle.scss'

export class ToastNotificationService {
    private $mdToast: angular.material.IToastService;

    constructor($mdToast: angular.material.IToastService) {
        this.$mdToast = $mdToast;
    }

    generateSuccessMessage = (message) => {
        this.$mdToast.show(
            this.$mdToast.simple()
                .toastClass("success_toast")
                .textContent(message)
                .hideDelay(5000)
        )
    };


    generateErrorMessage = message => this.generateErrorMessageWithDelay(message, 5000);



    generateErrorMessageWithDelay = (message, dellay: number) => {
        this.$mdToast.show(
            this.$mdToast.simple()
                .toastClass("error_toast")
                .textContent(message)
                .hideDelay(dellay)
        )
    };

    generateWarningMessage = (message) => {
        this.$mdToast.show(
            this.$mdToast.simple()
                .toastClass("warning_toast")
                .textContent(message)
                .hideDelay(5000)
        )
    };
}

export const NOTIFICATIONS_SERVICE = ['$mdToast', ToastNotificationService];
